export default __webpack_public_path__ + "static/media/colors-grayCharcoal.e76f0fe3.jpg";